import type { PlanDuration } from '@weft/types';
import { UNLIMITED_DURATION } from '@weft/types';
import { entries } from '@weft/utils';
import React from 'react';
import { type Control } from 'react-hook-form';
import { PlanSettingsAutoCompleteField } from './PlanSettingsAutoCompleteField';
import type { PlanSettingsSelectItem } from './PlanSettingsSelect';

type PlanDurationAutoCompleteProps = {
  className?: string;
  defaultValue?: PlanDuration;
  disabled?: boolean;
  control: Control;
  name: string;
};

export const PlanDurationAutoComplete: React.FC<PlanDurationAutoCompleteProps> = ({ className, control, name, defaultValue, disabled = false }) => {
  const defaultValueAsItem = getPlanDurationValues().find(({ value }) => value === defaultValue);

  return (
    <PlanSettingsAutoCompleteField 
      control={control}
      name={name}
      className={className}
      values={getPlanDurationValues()}
      disabled={disabled}
      label='Plan duration'
      defaultItem={defaultValueAsItem}
      mapValueChange={inputNumber => inputNumber}
    />
  );
};

function getPlanDurationValues(): PlanSettingsSelectItem<PlanDuration>[] {
  const planDurations = Array.from({ length: 10 }, (_, i) => i + 2).reduce<Record<PlanDuration, string>>((acc, i) => {
    acc[i] = `${i} months`;

    return acc;
  }, {
    1: '1 month',
    12: '1 year',
    18: '18 months',
    24: '24 months',
    [UNLIMITED_DURATION]: 'Unlimited',
  });

  return entries(planDurations).map(([value, label]) => ({
    value: Number(value),
    label,
  }));
}

export function getPlanDurationLabel(duration: PlanDuration): string {
  return getPlanDurationValues().find(({ value }) => value === duration)?.label ?? `${duration} months`;
}